import React from 'react';

import getFormatPrice from '@functions/getFormatPrice';

export default function Amount({ payGroup }: { payGroup: { amount: number } }): React.ReactNode {
    return (
        <div className="v2table__text _NOWRAP">{getFormatPrice(+payGroup.amount.toFixed(2))} ₽</div>
    );
}
